export default __webpack_public_path__ + "95145c493348b85905bc6ccd9f463f29.ttf";